import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取登录验证码
 * @return {*}
 */
export function sendSmsCode(phone, imageKey, imageCode) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Auth/SendSmsCode`,
    method: 'get',
    params: {
      accType: 2,
      accId: phone,
      imageKey,
      imageCode
    }
  })
}

/**
 * 获取登录验证码
 * @return {*}
 */
export function getVerificationImage() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Auth/getVerificationImage`,
    method: 'get'
  })
}

/**
 * 登录
 * @return {*}
 */
export function login(phone, password, appVersion) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Auth/Login`,
    method: 'get',
    params: {
      accType: 2,
      appId: 32,
      accId: phone,
      pwd: password,
      appVersion
    }
  })
}
/**
 * 大咖登录
 * @return {*}
 */
export function authorLogin(imageKey, imageCode, phone, password) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Auth/AuthorLoginAsync`,
    method: 'get',
    params: {
      imageKey: imageKey,
      code: imageCode,
      phone: phone,
      pwd: password
    }
  })
}

/**
 * 获取热门管理人（又名讲师、大咖）
 * @return {*}
 */
export function getHotAuthors(limit = 0) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Author/HotAuthors`,
    method: 'get',
    params: {
      limit: limit
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取当前用户信息
 */
export function getUserInfo() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/User/Info`,
    method: 'get'
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch((data) => {
      console.log('error:', data)
    })
}
/**
 * 获取当前用户信息
 */
export function getAuthorInfo() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Auth/GetAuthorDetail`,
    method: 'get'
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch((data) => {
      console.log('error:', data)
    })
}
export function updateUserNickAvatar(avatar, nick) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/User/Update`,
    method: 'post',
    data: {
      avatar: avatar,
      nick: nick
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 关注
 * @param {string} authorId id
 * @param {number} follow 1 关注 0 取消关注
 * @return {Promise<* | null>}
 */
export function followAuthor(authorId, follow) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/User/Follow`,
    method: 'post',
    data: {
      authorId,
      follow
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : false
    })
    .catch(() => false)
}

/**
 * 获取明星大咖
 * @return {*}
 */
export function getStarAuthors(type) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Author/GetStarAuthors`,
    method: 'get',
    params: {
      type: type
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}
